export const REQUEST_POST_FORGOT_PASSWORD = 'REQUEST_POST_FORGOT_PASSWORD'
export const RECEIVE_POST_FORGOT_PASSWORD = 'RECEIVE_POST_FORGOT_PASSWORD'
